<div [formGroup]="formUpload" class="page-section card">
  <div class="card-body d-flex flex-column gap-3">
    <div class="row">
      <div class="col-12 col-sm-4">
        <div class="flex flex-column gap-2">
          <p-inputMask formControlName="curp" placeholder="CURP" mask="******************" styleClass="w-100 h-50px"></p-inputMask>

          <small class="ps-2"><span class="text-danger">Requerido *</span></small>
        </div>
      </div>
      <div class="col-12 col-sm-4">
        <div class="mb-3 mb-sm-0 flex flex-column gap-2">
          <input placeholder="Correo Electrónico" formControlName="email" type="email" pInputText class="w-100 h-50px" />
          <small class="ps-2"><span class="text-danger">Requerido *</span></small>
        </div>
      </div>
      <div class="col-12 col-sm-4">
        <p-button label="Consultar" class="d-block h-50px" styleClass="h-100" [loading]="isSaving" (onClick)="consult()" [disabled]="this.formUpload.invalid" />
      </div>
    </div>
  </div>
</div>

<div class="page-section card">
  <div class="card-body p-0">
    <p-table #dt1 [value]="this.list" [rows]="25" [showCurrentPageReport]="true" [rowsPerPageOptions]="[25, 50, 100]" [paginator]="true" [globalFilterFields]="['curp', 'email']">
      <ng-template pTemplate="caption">
        <div class="d-flex align-items-stretch justify-content-between gap-2">
          <p-inputgroup>
            <p-iconfield class="w-100">
              <p-inputicon styleClass="pi pi-search" />
              <input
                type="text"
                pInputText
                [(ngModel)]="searchValue"
                (input)="dt1.filterGlobal(searchValue, 'contains')"
                placeholder="Buscar por CURP o Correo Electrónico."
                class="w-100 h-50px rounded-end-0"
              />
            </p-iconfield>
            <p-inputgroup-addon *ngIf="searchValue" pTooltip="Limpiar busqueda">
              <p-button icon="pi pi-times" severity="secondary" class="h-100" styleClass="h-100" (click)="searchValue = ''; dt1.filterGlobal(searchValue, 'contains')" />
            </p-inputgroup-addon>
          </p-inputgroup>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th>CURP</th>
          <th>CORREO ELECTRÓNICO</th>
          <th>ESTATUS</th>
          <th>FECHA</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td class="text-nowrap">{{ item.curp }}</td>
          <td class="text-nowrap">{{ item.email }}</td>
          @if (item.status === 'SUCCESS') {
          <td class="text-nowrap">
            <p-tag value="OK" severity="success" class="fw-normal cursor-pointer" />
          </td>
          } @else {
          <td class="text-nowrap">
            <p-tag value="Error" severity="danger" class="fw-normal cursor-pointer" (click)="showError(item.message)" />
          </td>
          }

          <td class="text-nowrap">{{ item.dateCreated | date : "longDate" }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="6">No se encontraron registros.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog
  header="Error"
  [(visible)]="statusModalError"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
>
  <div class="text-danger">{{ itemError }}</div>
</p-dialog>
